import React, { lazy, memo, Suspense } from 'react';
import styled from 'styled-components';
import  Spinner  from 'ui-kit/Spinner';

import useDocumentTitle from '../../../hooks/useDocumentTitle';
import UserTemplate from '../../templates/UserTemplate/UserTemplate';
import { Description, Title } from './styles';


const sections = {
  GeneralSection: lazy(() => import('./components/GeneralSection')),
  ContentPolicySection: lazy(() => import('./components/ContentPolicySection')),
  PaymentSection: lazy(() => import('./components/PaymentSection')),
  LinkToOtherWebsitesSection: lazy(() => import('./components/LinkToOtherWebsitesSection')),
  ModificationPolicySection: lazy(() => import('./components/ModificationPolicySection')),
  CopyrightInfringementSection: lazy(() => import('./components/CopyrightInfringementSection')),
  WarrantiesAndLiabilitySection: lazy(() => import('./components/WarrantiesAndLiabilitySection')),
  ContentMonitoringPolicySection: lazy(() => import('./components/ContentMonitoringPolicySection')),
  IntellectualPropertySection: lazy(() => import('./components/IntellectualPropertySection')),
  DisputeResolutionSection: lazy(() => import('./components/DisputeResolutionSection')),
  PromotionsSection: lazy(() => import('./components/PromotionsSection')),
  YourSubmissionsSection: lazy(() => import('./components/YourSubmissionsSection')),
  MiscellaneousSections: lazy(() => import('./components/MiscellaneousSections')),
  ContactUsSection: lazy(() => import('./components/ContactUsSection')),
};

const TermsOfServiceApp = () => {
  useDocumentTitle('Terms of Service');

  return (
    <UserTemplate currentName="index" stickyHeader>
      <Wrapper>
        <Title>Terms of Service</Title>
        <Description>Last updated: April 03, 2025</Description>
        {Object.entries(sections).map(([name, Component]) => (
          <Suspense key={name} fallback={<Spinner />}>
            <Component />
          </Suspense>
        ))}
      </Wrapper>
    </UserTemplate>
  );
};

export default memo(TermsOfServiceApp);

const Wrapper = styled.div`
  padding-top: 100px;
  padding-bottom: 2.5rem;
  width: 100%;
  box-sizing: border-box;
  color: white;

  h1, h2, h3, h4 {
    margin: 12px 0;
  }

  h1 {
    font-size: 36px;
  }

  h2 {
  font-family: Raleway;
  font-weight: 700;
  font-size: 20px;
  line-height: 22px;
  margin: 40px 0 12px 0;
  }

  h3 {
  font-family: Nunito Sans;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  margin: 40px 0 12px 0;
  }

  h4 {
  font-family: Nunito Sans;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  }

  a {
    text-decoration: underline;
  }

  ul {
    list-style-type: disc; 
    padding-left: 20px;

    li {
    list-style-type: disc;
    color: #A9A9A9;
    padding-left: 0px;
    &::before {
      content: '•'; 
      color: #A9A9A9;
      font-size: 16px;
      position: absolute;
      left: 0;
      top: 0;
    }

      p {
        font-family: Nunito Sans;
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        color: #A9A9A9;
        margin: 0; 
      }

      strong {
        font-weight: 700;
        color: white; 

      a {
        color: #00aaff; 
        text-decoration: none;
      }

      a:hover {
        text-decoration: underline;
      }
    }
      
`;
